var loginMain = require('./login');

$(function () {
    loginMain.loginStart();
});